
import { useNavigate } from 'react-router-dom';

export function BrandsSection() {
  const navigate = useNavigate();
  
  const brands = [
    {
      name: '온기',
      subtitle: '女',
      description: '여성을 위한 따뜻한 에너지',
      color: 'bg-rose-100 text-rose-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/2ec179d6187eeb08035c01720c7cb622.png',
      route: '/product/warmth'
    },
    {
      name: '회복',
      subtitle: '休',
      description: '휴식과 회복의 시간',
      color: 'bg-blue-100 text-blue-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/f95573aede0714f5d973d5793b7b5f41.png',
      route: '/product/recovery'
    },
    {
      name: '활력',
      subtitle: '男',
      description: '남성을 위한 역동적 에너지',
      color: 'bg-orange-100 text-orange-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/689e9628a8a5c4e866664d122697816d.png',
      route: '/product/vitality'
    },
    {
      name: '청결',
      subtitle: '足',
      description: '깨끗하고 상쾌한 케어',
      color: 'bg-cyan-100 text-cyan-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/641673050a28a0d8e3a498ee8435fb07.png',
      route: '/product/freshness'
    },
    {
      name: '숨결',
      subtitle: '林',
      description: '자연의 신선한 숨결',
      color: 'bg-green-100 text-green-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/fbeef199878546e975c8dff34069d395.png',
      route: '/product/breath'
    },
    {
      name: '두뇌',
      subtitle: '光',
      description: '집중력과 명료함',
      color: 'bg-purple-100 text-purple-600',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/ccd117ee05d642cbdabc3f7f51181509.png',
      route: '/product/brain'
    }
  ];

  const handleBrandClick = (brand: typeof brands[0]) => {
    if (brand.route) {
      navigate(brand.route);
    }
  };

  return (
    <section id="brands" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            천연 허브의 향과 에너지를 담은 여섯 가지 브랜드 자연림

          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            각각의 향으로 일상 속 균형과 안정을 회복하게 해주는 라코스벨의 브랜드 라인업
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {brands.map((brand, index) => (
            <div 
              key={index} 
              className="group cursor-pointer"
              onClick={() => handleBrandClick(brand)}
            >
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-emerald-200">
                <div className="w-16 h-16 rounded-full overflow-hidden mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md">
                  <img 
                    src={brand.image}
                    alt={brand.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                <div className="mb-4">
                  <h4 className="text-2xl font-bold text-gray-900 mb-1">{brand.name}</h4>
                  <span className="text-lg text-gray-500 font-medium">{brand.subtitle}</span>
                </div>
                
                <p className="text-gray-600 leading-relaxed">{brand.description}</p>
                
                <div className="mt-6 flex items-center text-emerald-600 group-hover:text-emerald-700 transition-colors">
                  <span className="text-sm font-medium">자세히 보기</span>
                  <div className="w-4 h-4 flex items-center justify-center ml-2 group-hover:translate-x-1 transition-transform">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
